import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyDetailComponent } from './survey-detail/survey-detail.component';
import { SurveysComponent } from './surveys/surveys.component';
import { ViewComponent } from './view/view.component';
import { RouterModule } from '@angular/router';
import { AuthGuard } from 'app/core/auth.guard';
import { PrepareGuard } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { ListComponent } from './list/list.component';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'interests',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'view', pathMatch: 'full' },
                    { path: 'view', component: ViewComponent, data: { title: 'Interests' }, canActivate: [AuthGuard, PrepareGuard] },
                    {
                        path: 'surveys',
                        component: SurveysComponent,
                        data: { title: 'Interests - Surveys' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'surveys/:id',
                        component: SurveyDetailComponent,
                        data: { title: 'Interests - Survey' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'list',
                        component: ListComponent,
                        data: { title: 'Interests - List' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],
})
export class InterestsModule {}
